import { render, staticRenderFns } from "./RX.vue?vue&type=template&id=739aae20&"
import script from "./RX.vue?vue&type=script&lang=js&"
export * from "./RX.vue?vue&type=script&lang=js&"
import style0 from "./RX.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports